import { useAppSelector } from "../../util/hooks";

type FiltroProps = {
  abrir: boolean;
  funcao: () => void;
};

export const Filtro = ({ abrir, funcao }: FiltroProps) => {
  //estados globais
  const configuracoesState = useAppSelector((state) => state.configuracoes);

  return (
    <a style={{ width: "fit-content" }} onClick={funcao}>
      {abrir ? "Ocultar filtros" : `Mostrar filtros ${configuracoesState.filtros.length > 0 ? `(${configuracoesState.filtros.length})` : ""}`}
    </a>
  );
};
